import { parseMealItems } from './parser'
import type { MealDay, MealsRange } from './types'

const BASE_URL = 'https://open.neis.go.kr/hub/mealServiceDietInfo'

type NeisRow = {
  MLSV_YMD?: string
  DDISH_NM?: string
  MMEAL_SC_NM?: string
}

type NeisResult = {
  CODE?: string
  MESSAGE?: string
}

type NeisJson = {
  RESULT?: NeisResult
  mealServiceDietInfo?: Array<{ head?: any; row?: NeisRow[] }>
}

function requireEnv(name: string): string {
  const value = (import.meta as any).env?.[name] as string | undefined
  if (!value) throw new Error(`환경변수 누락: ${name}`)
  return value
}

export function getNeisConfig() {
  const key = requireEnv('VITE_NEIS_KEY')
  const atpt = (import.meta as any).env?.VITE_ATPT_OFCDC_SC_CODE || 'B10'
  const school = (import.meta as any).env?.VITE_SD_SCHUL_CODE || '7010911'
  return { key, atpt, school }
}

export async function fetchLunchMeals(range: MealsRange): Promise<Record<string, MealDay>> {
  const { key, atpt, school } = getNeisConfig()
  const params = new URLSearchParams({
    KEY: key,
    Type: 'json',
    pIndex: '1',
    pSize: '100',
    ATPT_OFCDC_SC_CODE: atpt,
    SD_SCHUL_CODE: school,
    MMEAL_SC_CODE: '2',
    MLSV_FROM_YMD: range.fromYmd,
    MLSV_TO_YMD: range.toYmd,
  })

  const url = `${BASE_URL}?${params.toString()}`
  const res = await fetch(url)
  if (!res.ok) throw new Error(`NEIS 요청 실패: ${res.status}`)

  const json = (await res.json()) as NeisJson

  const rootResult = json.RESULT
  if (rootResult?.CODE && rootResult.CODE !== 'INFO-000') {
    if (rootResult.CODE === 'INFO-200') return {}
    throw new Error(`${rootResult.CODE}: ${rootResult.MESSAGE || 'NEIS 오류'}`)
  }

  const blocks = json.mealServiceDietInfo || []
  const rows = blocks.flatMap((b) => b.row || [])

  const out: Record<string, MealDay> = {}
  for (const r of rows) {
    const ymd = r.MLSV_YMD
    const dish = r.DDISH_NM
    if (!ymd || !dish) continue
    out[ymd] = {
      ymd,
      raw: dish,
      items: parseMealItems(dish),
    }
  }
  return out
}
